import { render, staticRenderFns } from "./UiModalPortal.vue?vue&type=template&id=5606d35d&"
import script from "./UiModalPortal.vue?vue&type=script&lang=js&"
export * from "./UiModalPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports